<template>
  <div class="countryPhoneCode">
    <v-select
      v-model="select"
      :items="phoneCodes"
      :link="false"
      required
      :outlined="outlined"
      append-icon="mdi-chevron-down"
      hide-details
      @change="handleSelect($event)"
    >
      <template v-slot:selection="{ item }">
        <span class="countryPhoneCode_label">
          {{ displayPhoneCode(item) }}
        </span>
      </template>
      <template #item="{ item }">
        <span class="font-14">
          {{ displayPhoneCode(item) }}
        </span>
      </template>
    </v-select>
  </div>
</template>

<script>
import { getCountryCodeList } from '@/utils/iso';

export default {
  name: 'CountryPhoneCode',
  props: {
    defaultCode: {
      type: String,
      default: '+81',
    },
    outlined: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      select: {
        code: '+81',
        name: '日本',
      },
      selected: {
        code: '+81',
        name: '日本',
      },
      phoneCodes: getCountryCodeList(),
    };
  },
  watch: {
    defaultCode(val) {
      this.select = this.phoneCodes.find((item) => item.code === val);
      this.selected = this.select;
    },
  },
  created() {
    this.select = this.phoneCodes.find(
      (item) => item.code === this.defaultCode
    );
    this.selected = this.select;
  },
  methods: {
    displayPhoneCode(item) {
      return item ? `${item.name} (${item.code})` : '日本（+81）';
    },
    handleSelect(item) {
      this.selected = item;
      this.$emit('select', item);
    },
  },
};
</script>
<style lang="scss">
.v-menu__content {
  @include scrollBarCustom;
  .v-list.v-select-list {
    padding: 0;
    .v-list-item--link {
      color: black !important;
      &:before {
        background-color: white;
      }
    }
  }
}
.countryPhoneCode {
  .v-input__control {
    width: 340px;
  }

  &_btn {
    width: 340px;
    padding: 0 !important;
    justify-content: space-between;

    &:before {
      background-color: unset;
    }
  }

  &_pulldown {
    margin-left: 12px;
    color: var(--background-color-3);

    &-open {
      transform: rotate(180deg);
    }
  }

  &_label {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
    text-transform: capitalize;

    &.label-placeholder {
      color: var(--text-color-4);
    }
  }

  &-icon {
    color: #0075c2;
    font-size: 18px;
    font-weight: 100;
    margin-right: 6px;

    &-gap {
      width: 20px;
      display: inline-block;
    }
  }

  &-map {
    .v-btn {
      font-size: 14px !important;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b !important;
    }
  }

  &_content {
    @include scrollBarCustom;
    min-width: fit-content !important;
    max-height: 200px;
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
    background-color: #fff;

    .v-list-item {
      padding: 0;
      min-height: 26px;

      &__title {
        text-align: left;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: normal;
        color: #666;
      }
    }

    .active-select-map {
      color: #0075c2;
    }
  }
}
</style>
